export default {
  PROJECTS_SET_LOADING: 'PROJECTS_SET_LOADING',

  PROJECTS_REQUEST: 'PROJECTS_REQUEST',
  PROJECTS_FAILURE: 'PROJECTS_FAILURE',
  PROJECTS_SUCCESS: 'PROJECTS_SUCCESS',

  PROJECTS_RESET: 'PROJECTS_RESET',
};
